<template>
  <div class="product-detail">
    <div class="modal-background" @click.self="close()">
      <div class="modal-wrapper" :class="$mq">
        <div class="modal" :class="$mq">
          <h1>
            <span v-show="economy > 0">
              {{ economy | toCurrency }}€ {{ $t('comparison.product.economy') }}
            </span>
            <span class="close" @click="$emit('close')"></span>
          </h1>
          <div class="comparison inline top" :class="{TA:isTestAchat}">
            <div class="range" :class="$mq">
              <h2><img src="@/assets/logoMegaHeader.svg" /></h2>
              <div class="price">
                <div class="inline center">
                  <span class="bold">{{ range.amounts.annual | toCurrency }}</span>
                  <span class="unit">
                    {{ $t(`simulation.product.${amountType}`) }} <br />
                    {{ $t("simulation.product.annualy") }}<sup v-if="!!findDiscountDD">**</sup>
                  </span>
                </div>
                <div class="inline center">
                  <span>{{ range.amounts.monthly | toCurrency }}</span>
                  <span class="unit">
                    {{ $t(`simulation.product.${amountType}`) }} <br />{{
                      $t("simulation.product.monthly")
                    }}
                  </span>
                </div>
              </div>
              <div class="details" v-if="hasElec">
                <h2 class="product">
                  <SvgIcon icon="electricity"></SvgIcon>
                  {{ productName(range.electricity) }}
                </h2>
                <table class="price-detail">
                  <tr>
                    <th></th>
                    <th>c€/kWh</th>
                    <th>€/{{ $tc("simulation.product.year") }}</th>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.subscription") }}</td>
                    <td></td>
                    <td>{{ range.electricity.subscription[priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr v-if="range.electricity.subtotal.discount">
                    <td>{{$t('comparison.product.detail.discount')}}</td>
                    <td></td>
                    <td>{{ range.electricity.subtotal.discount[priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr v-for="meterType in elecMeterTypes" :key="meterType">
                    <td>{{ $tc(meterType, elecMeterTypes.length) }}</td>
                    <td>{{ range.electricity.energy[meterType][unitaryPriceEuro] * 100 | toCurrency }}</td>
                    <td>{{ range.electricity.energy[meterType][priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.ecoTaxes") }}</td>
                    <td>{{ range.electricity.subtotal.renewable[unitaryPriceEuro] *100 | toCurrency }}</td>
                    <td>{{ range.electricity.subtotal.renewable[priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.transport") }}</td>
                    <td></td>
                    <td>{{ range.amounts.electricity.transport | toCurrency }}</td>
                  </tr>
                  <tr v-if="isProsumer">
                    <td>{{ $t("comparison.product.detail.prosumer") }}</td>
                    <td></td>
                    <td>{{ range.amounts.electricity.prosumer | toCurrency }}</td>
                  </tr>
                  <tr v-if="range.amounts.electricity.forfaitPv">
                    <td>{{ $t("comparison.product.detail.forfaitPv") }}</td>
                    <td></td>
                    <td>{{ range.amounts.electricity.forfaitPv | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.taxes")}}</td>
                    <td></td>
                    <td>{{ range.amounts.electricity.taxes | toCurrency }}</td>
                  </tr>
                  <tr class="total">
                    <td>{{ $t("comparison.product.detail.total") }}</td>
                    <td></td>
                    <td>{{ range.amounts.electricity.total | toCurrency }}</td>
                  </tr>
                </table>
              </div>
              <div class="details" v-if="hasGas">
                <h2 class="product">
                  <SvgIcon icon="gas"></SvgIcon>
                  {{ productName(range.gas) }}
                </h2>
                <table class="price-detail">
                  <tr>
                    <th></th>
                    <th>c€/kWh</th>
                    <th>€/{{ $tc("simulation.product.year") }}</th>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.subscription") }}</td>
                    <td></td>
                    <td>{{ range.gas.subscription[priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr v-if="range.gas.subtotal.discount">
                    <td>{{$t('comparison.product.detail.discount')}}</td>
                    <td></td>
                    <td>{{range.gas.subtotal.discount[priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.consumption") }}</td>
                    <td>{{ range.gas.energy.day[unitaryPriceEuro] * 100 | toCurrency }}</td>
                    <td>{{ range.gas.energy.day[priceEuro] | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('comparison.product.detail.transport')}}</td>
                    <td></td>
                    <td>{{ range.amounts.gas.transport | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.taxes") }}</td>
                    <td></td>
                    <td>{{ range.amounts.gas.taxes | toCurrency }}</td>
                  </tr>
                  <tr class="total">
                    <td>{{ $t("comparison.product.detail.total") }}</td>
                    <td></td>
                    <td>{{ range.amounts.gas.total | toCurrency }}</td>
                  </tr>
                </table>
              </div>
              <!-- ER-2932: conditional discounts of all the products, kept out of their totals (point B). -->
              <div class="cashback" v-if="cashbackLines(megaProducts).length">
                <div class="cashback__title">
                  <strong>{{ $t('cashback.label') }}</strong> {{ $t('cashback.conditional') }}
                  <strong>{{ cashbackTotal(megaProducts) | toCurrency }} €</strong>
                </div>
                <table class="cashback__lines">
                  <tr v-for="line in cashbackLines(megaProducts)" :key="line.code">
                    <td>{{ cashbackMention(line.code) }}</td>
                    <td class="cashback__amount">{{ line.amount | toCurrency }} €</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="range competitor" :class="$mq">
              <h2>{{ providerName }}</h2>
              <div class="price">
                <div class="inline center">
                  <span class="bold">{{ rangeCompetitor.amounts.annual | toCurrency }}</span>
                  <span class="unit">
                    {{ $t(`simulation.product.${amountType}`) }} <br />{{
                      $t("simulation.product.annualy")
                    }}
                  </span>
                </div>
                <div class="inline center">
                  <span>{{ rangeCompetitor.amounts.monthly | toCurrency }}</span>
                  <span class="unit">
                    {{ $t(`simulation.product.${amountType}`) }} <br />{{
                      $t("simulation.product.monthly")
                    }}
                  </span>
                </div>
              </div>
              <div class="details" v-if="hasElec">
                <h2 class="product">
                  <SvgIcon icon="electricity"></SvgIcon>
                  {{ rangeCompetitor.electricity[productNameTrad] }}
                </h2>
                <table class="price-detail">
                  <tr>
                    <th></th>
                    <th>c€/kWh</th>
                    <th>€/{{ $tc("simulation.product.year") }}</th>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.subscription") }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.electricity.subscription.priceEuroVAT | toCurrency }}</td>
                    <!-- <td>{{ rangeCompetitor.gas.total.priceEuroVAT | toCurrency }} €</td> -->
                  </tr>
                  <tr v-if="range.electricity.subtotal.discount">
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr v-for="meterType in elecMeterTypes" :key="meterType">
                    <td>{{ $tc(meterType, elecMeterTypes.length) }}</td>
                    <td>{{ rangeCompetitor.electricity.energy[meterType].unitaryPriceEuroVAT * 100 | toCurrency }}</td>
                    <td>{{ rangeCompetitor.electricity.energy[meterType].unitaryPriceEuroVAT * rangeCompetitor.electricity.energy[meterType].quantity | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.ecoTaxes") }}</td>
                    <td>{{ rangeCompetitor.electricity.subtotal.renewable.unitaryPriceEuroVAT * 100 | toCurrency }}</td>
                    <td>{{ rangeCompetitor.electricity.subtotal.renewable.unitaryPriceEuroVAT * rangeCompetitor.amounts.electricity.quantity | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('comparison.product.detail.transport') }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.electricity.transport | toCurrency }}</td>
                  </tr>
                  <tr v-if="isProsumer">
                    <td>{{ $t('comparison.product.detail.prosumer') }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.electricity.prosumer | toCurrency }}</td>
                  </tr>
                  <tr v-if="range.amounts.electricity.forfaitPv">
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.taxes") }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.electricity.taxes | toCurrency }}</td>
                  </tr>
                  <tr class="total">
                    <td>{{ $t("comparison.product.detail.total") }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.electricity.total | toCurrency }}</td>
                  </tr>
                </table>
              </div>
              <div class="details" v-if="hasGas">
                <h2 class="product">
                  <SvgIcon icon="gas"></SvgIcon>
                  {{ rangeCompetitor.gas[productNameTrad] }}
                </h2>
                <table class="price-detail">
                  <tr>
                    <th></th>
                    <th>c€/kWh</th>
                    <th>€/{{ $tc("simulation.product.year") }}</th>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.subscription") }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.gas.subscription.priceEuroVAT | toCurrency }}</td>
                    <!-- <td>{{ rangeCompetitor.gas.total.priceEuroVAT | toCurrency }} €</td> -->
                  </tr>
                  <tr v-if="range.gas.subtotal.discount">
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.consumption") }}</td>
                    <td>{{ rangeCompetitor.gas.energy.exclusiveDay.unitaryPriceEuroVAT * 100 | toCurrency }}</td>
                    <td>{{ rangeCompetitor.gas.energy.exclusiveDay.unitaryPriceEuroVAT * rangeCompetitor.gas.energy.exclusiveDay.quantity | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("comparison.product.detail.transport") }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.gas.transport | toCurrency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('comparison.product.detail.taxes') }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.gas.taxes | toCurrency }}</td>
                  </tr>
                  <tr class="total">
                    <td>{{ $t("comparison.product.detail.total") }}</td>
                    <td></td>
                    <td>{{ rangeCompetitor.amounts.gas.total | toCurrency }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <button v-if="!noSubscribe" class="button main become" @click="redirect()">{{ $t('Offer.Product.become') }}</button>
          <div class="condition inline space-around">
            <a target="_blank" :href="generalCondition">{{
              $t("generalCondition")
            }}</a>
            <a target="_blank" :href="pricing">{{ $t("pricing") }}</a>
          </div>
        </div>
        <button class="button main back" @click="close()">{{ $t('back') }}</button>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapGetters } from "vuex";
import capitalize from "@/mixins/capitalize.js";
import cashback from "@/mixins/cashback";


export default {
  mixins: [capitalize, cashback],
  props: {
    range: {
      type: Object
    },
    rangeCompetitor: {},
    findDiscountDD: Number
  },
  computed: {
    ...mapState("common", ["uuid"]),
    ...mapState("contact", ["isPro"]),
    ...mapGetters("consumption", ["elecMeterTypes"]),
    ...mapGetters("common", ["isTestAchat"]),
    isProsumer(){
      return this.range.amounts.electricity.prosumer > 0;
    },
    hasElec() {
      return this.range.electricity !== undefined;
    },
    hasGas() {
      return this.range.gas !== undefined;
    },
    megaProducts() {
      return [this.range.electricity, this.range.gas].filter(Boolean);
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    priceEuro() {
      return this.isPro ? "priceEuro" : "priceEuroVAT";
    },
    unitaryPriceEuro() {
      return this.isPro ? "unitaryPriceEuro" : "unitaryPriceEuroVAT";
    },
    productNameTrad() {
      return this.$i18n.locale === "fr" ? "labelFr" : "labelNl";
    },
    economy() {
      let economy =
        this.rangeCompetitor.amounts.annual - this.range.amounts.annual;

      let economyText = "";

      if (economy > 0) {
        economyText =
          this.$i18n.locale === "fr"
            ? ` et gagnez ${economy.toFixed(
                0
              )}€ par an ! Ça en fait des heures d'électricité ..`
            : ` in en win € ${economy.toFixed(
                0
              )} per jaar! Dat zijn heel wat uren elektriciteit..`;
      }
      this.$store.commit("comparison/setEconomyText", economyText);
      return economy;
    },
    generalCondition() {
      return this.$i18n.locale === "fr"
        ? "https://www.mega.be/fr/conditions-generales-de-vente"
        : "https://www.mega.be/nl/algemene-voorwaarden";
    },
    pricing() {
      return this.$i18n.locale === "fr"
        ? "https://www.mega.be/fr/electricite-et-gaz/tarif-gaz-electricite"
        : "https://www.mega.be/nl/elektriciteit-en-aardgas/energieprijzen";
    },
    // async redirect() {
    //   let data = {
    //     uuid: this.uuid,
    //   };

    //   if (this.range.electricity) {
    //     this.range.electricity['wantGreen'] = this.wantGreen ? 1 : 0;
    //     data["megaProductElec"] = this.range.electricity;
    //   }

    //   if (this.range.gas) {
    //     this.range.gas['wantGreen'] = this.wantGreen ? 1 : 0;
    //     data["megaProductGas"] = this.range.gas;
    //   }

    //   try {
    //     await leadService.save(data);
    //   } catch (error) {
    //     console.log(error.response);
    //   }

    //   if(this.agentJwt)
    //     window.location.href = `${process.env.BECOME}/agent/?newSession&agent=${this.$route.query['agent']}&jwt=${this.agentJwt}&lead=${this.uuid}`;
    //   else
    //     window.location.href = `${process.env.BECOME}/lead/${this.uuid}`;

    // },
    become() {
      return this.$store.getters["middleware/become"](this.range);
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
    providerName() {
      let providerName = "";
      let locale = "";

      if(this.$i18n.locale === "fr")
        locale = "Fr";
      else if (this.$i18n.locale === "nl")
        locale = "Nl"

      if (this.rangeCompetitor && this.rangeCompetitor.electricity && this.rangeCompetitor.electricity[`competitor${locale}`]) {
        providerName = this.rangeCompetitor.electricity[`competitor${locale}`];
        if (this.rangeCompetitor && this.rangeCompetitor.gas && this.rangeCompetitor.gas[`competitor${locale}`]
        && this.rangeCompetitor.gas[`competitor${locale}`] !== this.rangeCompetitor.electricity[`competitor${locale}`])
          providerName += ' - ' + this.rangeCompetitor.gas[`competitor${locale}`];
      } else if(this.rangeCompetitor && this.rangeCompetitor.gas && this.rangeCompetitor.gas[`competitor${locale}`])
        providerName = this.rangeCompetitor.gas[`competitor${locale}`];

      return providerName;
    }
  },
  methods: {
    async redirect() {
      let data = {
        uuid: this.uuid,
      };

      if (this.range.electricity) {
        this.range.electricity['wantGreen'] = this.wantGreen ? 1 : 0;
        data["megaProductElec"] = this.range.electricity;
      }

      if (this.range.gas) {
        this.range.gas['wantGreen'] = this.wantGreen ? 1 : 0;
        data["megaProductGas"] = this.range.gas;
      }

      try {
        await leadService.save(data);
      } catch (error) {
        console.error(error.response);
      }

      if(this.agentJwt)
        window.location.href = `${process.env.BECOME}/agent/?newSession&agent=${this.$route.query['agent']}&jwt=${this.agentJwt}&lead=${this.uuid}`;
      else
        window.location.href = `${process.env.BECOME}/lead/${this.uuid}?newSession`;
    },
    close() {
      this.$emit("close");
    },
    productName(product) {
      return this.$store.getters["comparison/productName"](
        product
      );
    }
  },
  filters: {
    toCurrency: function(value) {
      return value.toFixed(2).replace(".", ",");
    }
  },
  created() {
    let body = document.body;
    body.classList.add("modal-open");
  },
  destroyed() {
    let body = document.body;
    body.classList.remove("modal-open");
  }
};
</script>

<style lang="scss" scoped>
// Koopkracht: conditional discounts block, after the product tables.
.cashback {
  margin: 20px 0 15px;

  &__title {
    margin: 0;
    padding: 8px 5px;
    background: $pink;
    color: $white;
    font-size: 0.9rem;
    text-align: center;

    strong {
      font-size: 1.1rem;
    }
  }

  &__lines {
    width: 100%;
    font-size: 0.8rem;
    background: $white;
    border-collapse: collapse;

    tr:nth-child(even) {
      background: $lightGrey;
    }

    td {
      padding: 5px;
    }

    td:first-child {
      text-align: left;

      &::first-letter {
        text-transform: uppercase;
      }
    }
  }

  &__amount {
    color: $pink;
    font-weight: 600;
    white-space: nowrap;
  }
}

h1 {
  display: flex !important;
  justify-content: center;
  align-items: center;
  background: $yellow;
  display: block;
  text-align: center !important;
  margin: 5px;
  font-size: 1.2rem !important;

  &.TA {
    background: $orange!important;
  }

  .icon {
    margin-right: 5px;
    font-size: 1.6rem !important;
  }
}

.comparison .range {
  flex: 1;

  > h2 {
    margin: 0!important;
    height: 50px;
    display: flex!important;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      height: 80%;
    }
  }

  .price {
    // background: $clearYellow;
    padding: 10px 0;

    div {
      margin-bottom: 5px;
    }

    .unit {
      display: block;
      font-size: 0.5rem;
      width: 45px;
    }

    .bold {
      font-weight: bold;
    }
  }

  &.competitor {
    border-left: 3px solid #fff;

    &.mobile {
      margin-top: 20px;
      border-left: 0;
    }

    > h2 { background: #e4e4e4 }
  }

  .details {
    // background: $clearYellow;

    &:last-child { margin-top: 30px };

    .product {
      margin: 0 !important;
      padding: 5px;
      font-size: 0.8rem !important;
      display: flex !important;
      justify-content: center;
      background: $clearYellow;
    }

    .price-detail {
      width: 100%;
      font-size: 0.8rem;
      background: $white;
      border-collapse: collapse;

      th {
        font-weight: 600;
        padding: 5px 0;
      }

      tr td:first-child {
        padding-left: 5px;
        text-align: left;
      }

      tr:nth-child(even) {
        background: $lightGrey;
      }

      .total {
        font-weight: 600;
        background: #e4e4e4!important;
      }

      td {
        padding: 5px 0;
      }

    }
  }

  &.competitor {
    .product { background: #e4e4e4 };
    .details .price-detail .total {
      background: #e4e4e4!important;
    }
  }
}

.condition {
  position: relative;
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid #e2e2e2;
  width: 100%;

  a {
    min-width: 200px;
    text-decoration: underline;
    font-size: 0.8rem;
    color: #ccc;
  }
}

.back {
  margin-top: 10px;
}
.become {
  margin-bottom: 10px;
  background: $yellow !important;
}

.disclaimer {
  margin: 1rem;
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/views/comparison/Details.vue